/* eslint-disable @typescript-eslint/no-shadow */
import { useCallback, useEffect, useRef, useState } from 'react';

type TimerState = {
    time: number;
    start: number;
};

export const useTimer = () => {
    const timer = useRef<NodeJS.Timeout | null>(null);
    const [state, setState] = useState<TimerState>({ time: 0, start: 0 });

    const convertToSeconds = (amount: number): number => amount / 1000;
    const valueInSeconds = convertToSeconds(state.time);

    const startTimer = useCallback((): void => {
        setState((prevValue) => ({
            ...prevValue,
            start: Date.now(),
        }));

        timer.current = setInterval(
            () =>
                setState((prevValue) => ({
                    ...prevValue,
                    time: Date.now() - prevValue.start,
                })),
            1000,
        );
    }, []);

    const resetTimer = useCallback((): void => {
        setState((prevValue) => ({
            ...prevValue,
            start: Date.now(),
            time: 0,
        }));
    }, []);

    const stopTimer = useCallback(
        (isWithReset = true): void => {
            if (isWithReset) resetTimer();
            if (timer.current !== null) {
                clearInterval(timer.current);
                timer.current = null;
            }
        },
        [resetTimer],
    );

    useEffect(
        () => () => {
            stopTimer(true);
        },
        [stopTimer],
    );

    return { valueInSeconds, startTimer, stopTimer, resetTimer };
};
